import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'input[numbersOnly]'
})
export class NumberDirective {

    regexStr = '^[0-9]*$';
    @Input() isNumeric: boolean;

    constructor(private el: ElementRef) { }

    @HostListener('keypress', ['$event']) onKeyPress(event) {
        return new RegExp(this.regexStr).test(event.key);
    }

    @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
        this.validateFields(event);
    }

    validateFields(event) {
        setTimeout(() => {

            this.el.nativeElement.value = this.el.
                nativeElement.value.replace(/[^0-9]/g, '').replace(/\s/g, '');
            event.preventDefault();

        }, 100);
    }
}


